module.exports = __webpack_public_path__ + "img/電気回路_6_3_5.e72410da.png";